import script from "./CompaniesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CompaniesPage.vue?vue&type=script&setup=true&lang=js"

import "./CompaniesPage.vue?vue&type=style&index=0&id=75b6c2f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b6c2f2"]])

export default __exports__